import React from "react";

import CommonModal from "../../../Components/Modal";
import OrgProductTelemetryPanel from "../../OrgProductTelemetryPanel";
import "./style.scss";

interface TelemetricDataModalProps {
  isOpen: boolean;
  toggle: () => void;
  organizationName: string;
  orgId: string;
}

const TelemetricDataModal: React.FC<TelemetricDataModalProps> = ({
  isOpen,
  toggle,
  organizationName,
  orgId,
}) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title="Telemetric Data"
      subtitle={
        <>
          Product usage for <strong>{organizationName}</strong>
        </>
      }
      size="full"
      usePortal
      className="telemetric-data-modal !max-w-[90vw] w-[90vw]"
      contentClassName="overflow-y-auto"
    >
      {isOpen && orgId ? (
        <OrgProductTelemetryPanel
          orgId={orgId}
          organizationName={organizationName}
        />
      ) : null}
    </CommonModal>
  );
};

export default TelemetricDataModal;
